import { useState, useContext } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Sidebar from "./pages/nav/sidebar/sidebar";
import "bootstrap-icons/font/bootstrap-icons.css";
import Container from "react-bootstrap/Container";
import CustomNavbar from "./pages/nav/customNavbar.js";
import { Row, Col } from "react-bootstrap";
import { TokenProvider } from "./scripts/tokenContext";
import AppRoutes from "./AppRoutes";
import { DateProvider } from "./scripts/dateContext.js";
import { TreeProvider, default as TreeContext } from "./context/treeContext.js";

function MainContent() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();

  // Use o contexto para controlar o treeSidebarOpen e toggleTreeSidebar
  const { treeSidebarOpen, toggleTreeSidebar } = useContext(TreeContext);

  const toggleSidebar = () => {
    setSidebarOpen((prevSidebarOpen) => !prevSidebarOpen);
  };

  const isLoginPage = location.pathname.startsWith("/login");

  return (
    <Container fluid>
      {!isLoginPage && <CustomNavbar />}
      <Row className="containerConteudo">
        {!isLoginPage && (
          <Sidebar
            toggleSidebar={toggleSidebar}
            sidebarOpen={sidebarOpen}
            toggleTreeSidebar={toggleTreeSidebar}
            treeSidebarOpen={treeSidebarOpen}
          />
        )}
        <Col
          className={`content ${sidebarOpen ? "expanded" : ""} ${treeSidebarOpen ? "tree-expanded" : ""}`}
        >
          <AppRoutes />
        </Col>
      </Row>
    </Container>
  );
}

export function App() {
  return (
    <Router>
      <TokenProvider>
        <DateProvider>
          <TreeProvider>
            <div className="App">
              <MainContent />
            </div>
          </TreeProvider>
        </DateProvider>
      </TokenProvider>
    </Router>
  );
}

export default App;
